import { dashboardConstants } from "../_constants";

export function dashboard(
  state = { fetchingDetail: false, detail: {} },
  action
) {
  switch (action.type) {
    case dashboardConstants.DETAIL_REQUEST:
      return {
        fetchingDetail: true
      };
    case dashboardConstants.DETAIL_SUCCESS:
      return {
        fetchingDetail: false,
        detail: action.detail
      };
    case dashboardConstants.DETAIL_FAILURE:
      return {
        error: action.error
      };
    default:
      return state;
  }
}
